// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"03291e6d","677":"85771329"}[chunkId] + ".chunk.js";
};